import React from "react";

const Terms = () => {
  return (
    <section className="flex justify-center py-14">
      <div className="container 3xl:w-[70%] p-4 xl:px-20 space-y-6 text-base sm:text-lg md:text-xl lg:text-2xl space-y-4 py-4">
        <h2 className="font-bold text-xl">Terms &amp; Conditions</h2>

        <p>
          The DEFENCE PARTNERSHIP DAYS event organized by IMR Media Pvt Ltd
          (Organizer) will take place at the Manekshaw Centre, New Delhi on
          26-27 Nov 2026.
        </p>

        <p>
          In case of circumstances beyond the control of the Organizers
          (referred to as force majeure), the Organizer may choose to change the
          dates or the venue of this event or cancel it after notifying the
          participants.
        </p>

        <p>
          defencepartners.in is operated by currently provides by Organizer
          under the terms and conditions primarily set forth in this Terms of
          Use.{" "}
          <strong>
            BY ACCESSING OR USING THIS WEB SITE, YOU AGREE TO ABIDE BY THE TERMS
            OF USE.
          </strong>
        </p>

        <p>
          Subject to the Terms of Use, the Organizer grants you a non-exclusive,
          non-transferable, limited, conditionally revocable right to access,
          use and privately display this Web site for your legitimate personal
          and/or business needs.
        </p>

        <p>
          Any other use of this Web site is expressly prohibited and constitutes
          a material violation of the Terms of Use. Prohibited uses include,
          without limitation, using email addresses obtained from this Web site
          for solicitation purposes of any kind, directly or indirectly, the use
          of data mining, robots or other similar data gathering and extraction
          tools, and making any derivative works based, in whole or in part, on
          any portion or all of this Web site.
        </p>

        <p>
          You must be 18 years or older to use this Web site. Organizer reserves
          the right, at its sole discretion, to change, modify, add or remove
          the Terms of Use, in whole or in part, at any time without prior
          notice or liability.
        </p>

        <p>
          Your continued access or use of this Web site after any such change,
          modification, addition or removal of the Terms of Use will constitute
          your acceptance thereof.
        </p>

        <p>
          Further, Organizer reserves the right, at its sole discretion, and
          without prior notice or liability, to terminate, modify or add any
          features to this Web site at any time.
        </p>

        {/* LIMITING ACCESS */}
        <h3 className="font-bold text-lg pt-4">LIMITING ACCESS</h3>

        <p>
          Organizer reserves the right, as its sole discretion, and without
          prior notice or liability, to limit or terminate your access to this
          Web site and you agree to abide by such limit or termination.
        </p>

        {/* USE RESTRICTIONS */}
        <h3 className="font-bold text-lg pt-4">USE RESTRICTIONS</h3>

        <p>
          You agree not to modify, add or delete any content on this Web site,
          without the express written permission of Organizer. Further, you
          agree not to interrupt or attempt to interrupt the operation of this
          Web site or access thereto by other users.
        </p>

        <p>
          You agree not to resell or otherwise exploit for commercial purposes,
          directly or indirectly, any portion of this Web site, the services
          offered on this Web site, or access to this Web site.
        </p>

        <p>
          You agree that information you provide to this Web site or the
          manufacturers and distributors whose products are present in any
          online catalogue of this Web site will be true and accurate to the
          best of your knowledge.
        </p>

        <p>
          Nothing you provide shall be illegal, obscene, threatening,
          defamatory, invasive of privacy, infringing on the rights of, or
          otherwise injurious to person or property, including, without
          limitation, software viruses, worms, Trojan horses or other malicious
          code.
        </p>

        <p>
          You also agree not to use a false email address, impersonate any
          person or entity, or otherwise mislead as to the source of the
          information you provide to this Web site or to the manufacturers and
          distributors whose products are present in any online catalogue of
          this Web site.
        </p>

        {/* LINKING */}
        <h3 className="font-bold text-lg pt-4">LINKING TO THIS WEB SITE</h3>

        <p>
          You may link to this Web site, so long as it does not portray
          Organizer or its affiliates in a negative manner or otherwise portray
          its services in a false, misleading, derogatory or offensive manner.
        </p>

        <p>
          The linking site must not contain anything illegal, false, misleading,
          derogatory or offensive, and no express or implied affiliation with
          Organizer may be indicated without Organizer&apos;s express written
          permission.
        </p>

        <p>
          Organizer reserves the right to require that you remove any link to
          this Web site for any reason, and you agree to carry out the removal
          immediately.
        </p>

        <p>
          Unless specifically set forth in writing by Organizer, any link to
          this Web site must not appear prominently on the linking site so as to
          confuse or mislead users as to the affiliation, sponsorship, etc. of
          Organizer and the linking site.
        </p>

        {/* OWNERSHIP */}
        <h3 className="font-bold text-lg pt-4">
          OWNERSHIP AND INTELLECTUAL PROPERY
        </h3>

        <p>This Web site is owned and operated by Organizer.</p>

        <p>
          You may view, download, print and retain a copy of pages of our Web
          site only for your own legitimate personal and/or business needs.
        </p>

        <p>
          Except as expressly provided above, you may not use, download, upload,
          copy, print, display, perform, reproduce, republish, license, post,
          transmit or distribute any information from our Web site in whole or
          in part without our prior written permission.
        </p>

        <p>
          If you wish to obtain permission to reprint or reproduce any materials
          appearing on our Web site you may contact us at{" "}
          <a
            href="mailto:response@imrmedia.in"
            className="text-blue-600 underline"
          >
            response@imrmedia.in
          </a>
          . All rights not expressly granted herein are reserved.
        </p>

        <p>
          “IMR”, the Organizer design and flag and other marks appearing on this
          Web Site are trademarks of Organizer. Marks without the registration
          symbol are either under application for registration are considered to
          be common law marks of Organizer.
        </p>

        <p>
          You agree not to use any meta tags or other hidden text utilizing
          Organizer&apos;s name or any of its trademarks without the express
          written consent of Organizer.
        </p>

        <p>
          © 2026 IMR MEDIA PVT LTD. All Rights Reserved Throughout the World.
        </p>

        <p>
          Organizer claims a copyright interest in each page of this Web site
          and the Web site as a whole, as well as in the individual content,
          including, without limitation, any catalogue as a whole and all search
          forms.
        </p>

        <p>
          No portion of this Web site or the Web site as a whole may be copied,
          retransmitted, reposted, duplicated or otherwise used without the
          express written permission of Organizer.
        </p>

        {/* GENERAL */}
        <h3 className="font-bold text-lg pt-4">GENERAL</h3>

        <p>
          If any court of competent jurisdiction deems any provision of these
          Terms of Use to be unenforceable, then that provision shall be
          enforced to the extent possible to effect the intent of the Terms of
          Use, and the remaining provisions shall remain in full force and
          effect.
        </p>

        <p>
          The headings in this section of the Web site are intended solely for
          convenience and are not considered to be terms within the Terms of
          Use.
        </p>

        <p>
          The Terms of Use constitutes the entire agreement between Organizer
          and you with regard to your access and use of this Web site, and
          supersedes all prior agreements and understandings, whether written or
          oral, in connection herewith.
        </p>

        {/* DISCLAIMER */}
        <h3 className="font-bold text-lg pt-4">
          NO WARRANTY / DISCLAIMER / LIMITATIONS ON DAMAGES
        </h3>

        <p>
          Technical data and statistical information contained in any electronic
          catalogue of this Web site have been derived from information supplied
          by the respective manufacturers and distributors.
        </p>

        <p>
          Although we believe that the information supplied is generally
          correct, we do not assume any responsibility whatsoever for its
          accuracy.
        </p>

        <p>
          The data and information contained in any electronic catalogue are
          intended for use by persons possessing technical skill and knowledge.
        </p>

        <p>
          Conditions of use of the items listed in any electronic catalogue are
          beyond our knowledge or control and consequently we assume no
          liability whatsoever for results obtained or loss or damage incurred
          as a result of application of the data or information presented.
        </p>

        <p>
          Users of any electronic catalogue do so at their own risk. In
          addition, we assume no liability and make no warranty with respect to
          claims of patent, trademark or copyright infringement or other similar
          claims which may arise out of or in connection with the use of any
          data, information or items listed in any electronic catalogue.
        </p>

        <p>
          This website is provided on an “as is” and “as available” basis and
          IMR Media specifically disclaims warranties of any kind, either
          expressed or implied, including but not limited to warranties of title
          or implied warrantees of merchantability or fitness for a particular
          purpose.
        </p>

        <p>
          No oral advise or written or electronically delivered information
          given by IMR Media or its affiliates, or any of its officers,
          directors, employees, agents, providers, merchants, sponsors,
          licensors, or the like, shall create any warranty.
        </p>

        <p>
          You expressly agree that use of the web site is at your sole risk.
        </p>

        <p>
          In no event shall organizer be liable for any injury, expenses,
          profits, loss or damage, whether direct, incidental, or consequential,
          or any other pecuniary loss or expense.
        </p>

        <p>
          If, despite the language of the Terms of Use, Organizer becomes liable
          to you for anything arising out of or related in any way to your
          access, use or inability to use this Web site or any product described
          in any electronic catalogue, then Organizer total liability to you
          shall not exceed the total payments actually made by you to Organizer
          or INR 500, whichever is greater.
        </p>

        {/* INDEMNITY */}
        <h3 className="font-bold text-lg pt-4">INDEMNITY</h3>

        <p>
          You agree to indemnify and hold Organizer and, where applicable, its
          parent, subsidiaries, officers, directors, agents and employees, as
          well as manufacturers and distributors whose content appears on this
          Web site, harmless from any claim or demand, including reasonable
          attorney&apos;s fees, made by any third party arising out of or
          related in any way to your access, inability to access or use of this
          Web site, or any breach by you of the Terms of Use.
        </p>

        {/* THIRD PARTY */}
        <h3 className="font-bold text-lg pt-4">THIRD PARTY SITES / EMAIL</h3>

        <p>
          As a convenience to you, Organizer may provide on this Web site one or
          more links to third party Web sites and/or provide email contacts
          respecting third parties.
        </p>

        <p>
          Organizer makes no endorsement of such third parties, nor any
          representation or warranty regarding anything that takes place between
          you and such third parties.
        </p>

        <p>
          Such third parties are independent from and not controlled by
          Organizer, even if, for example, an Organizer link or logo appears on
          a Web site linked from this site.
        </p>

        <p>
          It is up to you to take whatever precautions are necessary to protect
          against viruses, worms, Trojan horses or other malicious code.
        </p>

        {/* INTERNATIONAL USERS */}
        <h3 className="font-bold text-lg pt-4">INTERNATIONAL USERS</h3>

        <p>
          This Web site is controlled, operated and administered by Organizer
          from within India.
        </p>

        <p>
          Organizer makes no representation that this Web site is available for
          access or use at other locations outside India. However, any access or
          use from outside India is still subject to the Terms of Use.
        </p>

        <p>
          Access to this Web site is expressly prohibited from territories where
          this Web site or any portion thereof is illegal.
        </p>

        <p>
          You agree not to access or use any information or materials in
          violation of Indian export laws and regulations, or in violation of
          any laws or regulations in the country from which you are accessing
          this Web site.
        </p>

        {/* THIRD PARTY CONTENT */}
        <h3 className="font-bold text-lg pt-4">
          THIRD PARTY CONTENT ON WEB SITE
        </h3>

        <p>
          IMR MEDIA is a distributor and not a publisher of the content supplied
          by third parties on the Web site. IMR MEDIA does not have editorial
          control over such content.
        </p>

        <p>
          Any opinions, advice, statements, services, offers, or other
          information that constitutes part of the content expressed or made
          available by third parties are those of the respective authors or
          distributors and not of IMR MEDIA or its affiliates.
        </p>

        <p>
          Neither IMR MEDIA nor its affiliates, nor their officers, directors,
          employees, agents, nor any third party guarantees the accuracy,
          completeness, or usefulness of any content.
        </p>

        <p>
          In many instances, the content available on the Web site represents
          the opinions and judgments of the respective merchants, suppliers,
          providers, sponsors, licensors, customers or users of the Web site.
        </p>

        <p>
          IMR MEDIA neither endorses nor is responsible for the accuracy or
          reliability of any opinion, advice, submission, posting, or statement
          made on the Web site by anyone other than authorized IMR MEDIA
          employees.
        </p>

        <p>
          Under no circumstances shall IMR MEDIA, or its affiliates, or any of
          their officers, directors, employees, or agents, nor any third party
          be liable for any loss or damage caused by your reliance on any
          content or other information obtained through the Web site.
        </p>

        {/* INFORMATION MANAGEMENT */}
        <h3 className="font-bold text-lg pt-4">INFORMATION MANAGEMENT</h3>

        <p>
          The event platform may involve third-party services; participants are
          subject to the terms and conditions of those services.
        </p>

        <p>
          By registering to the event, each participant authorizes Organizer to
          use his email address(es) and mobile numbers, for dispatching
          information regarding the event and promotion of other events
          organized by Organizer.
        </p>

        <p>
          These details may also be transmitted to the organizing partners. This
          information will allow informing the participants about upcoming
          events and receiving information by email; with personalized
          communication including sending newsletters, special offers and
          special emails within the communication framework of the event.
        </p>

        <p>
          Moreover, Organizer reiterates that if the participant changes his
          mind and no longer wishes to receive certain categories of emails, he
          can at any moment contact us in order to keep us informed about these
          mailings.
        </p>

        {/* COMPLIANCE */}
        <h3 className="font-bold text-lg pt-4">
          COMPLIANCE WITH LAWS AND EXPORT REGULATION
        </h3>

        <p>
          You agree to use this Web site and the content thereon in compliance
          with all applicable laws, statutes, ordinances and regulations
          governing your use of our Web site.
        </p>

        {/* ADVERTISING */}
        <h3 className="font-bold text-lg pt-4">ADVERTISING</h3>

        <p>
          Our Web site may contain third party advertisements and/or
          sponsorships. The advertisers and/or sponsors that provide these
          advertisements and sponsorships are solely responsible for ensuring
          that the materials submitted for inclusion on this Web site are
          accurate and comply with all applicable laws.
        </p>

        <p>
          We are not responsible for the acts or omissions of any advertiser or
          sponsor.
        </p>

        {/* JURISDICTION */}
        <h3 className="font-bold text-lg pt-4">
          CHOICE OF LAW / FORUM FOR DISPUTES / JURISDICTION
        </h3>

        <p>
          The validity, construction and performance of the Term of Use of this
          Web site and the legal relations between you and Organizer shall be
          governed by and construed in accordance with the laws of India,
          excepting its choice of law rules if the application of such rules
          would result in the laws of another jurisdiction being applied.
        </p>

        <p>
          Any dispute between you and Organizer arising out of or relating in
          any way to your access or use of this Web site shall initially be
          addressed through confidential negotiations, which shall be treated as
          compromise and settlement negotiations under the relevant rules of
          evidence.
        </p>

        <p>
          If the matter in dispute has not been resolved within thirty (30) days
          of the initiating party&apos;s written request for negotiation, the
          parties shall endeavour to first settle the dispute by mediation
          administered by the Indian rules.
        </p>

        <p>
          A neutral third party will be selected in accordance with the
          selection process. During the time period set forth below, mediation
          shall be the sole and exclusive procedure for resolution of any such
          dispute.
        </p>

        <p>
          Any dispute between you and Organizer described in the previous
          paragraph shall be brought before an alternative dispute resolution
          body within 50 kms of Organizer&apos;s corporate headquarters as of
          the date of the initiating party&apos;s written request for
          negotiation.
        </p>

        <p>
          You agree that any such body shall have personal jurisdiction over you
          for purposes of any such dispute.
        </p>

        <p>
          Further, any judgment on the award rendered by the arbitrator may be
          entered only in a court within 50 kms of Organizer&apos;s corporate
          headquarters as of the date the award is rendered.
        </p>

        <p>
          You agree that any such court shall have personal jurisdiction over
          you for purposes of any such judgment.
        </p>

        <p>
          You agree that the cost of mediation and any subsequent arbitration as
          described herein shall be split equally between you and Organizer.
        </p>

        <p>
          Should mediation or arbitration as described herein not take place or
          not completely resolve a dispute for any reason, you agree that the
          sole jurisdiction and venue for any litigation arising from your use
          of our Web site shall be an appropriate court of law located in New
          Delhi, and you hereby submit to the jurisdiction of these courts.
        </p>
      </div>
    </section>
  );
};

export default Terms;
